import * as JP from './lang.jp'

let LABELS = JP

export default LABELS
